export const dialogTransitionConfig = {
  from: {opacity: 0, transform: "translateY(-20px)"},
  enter: {opacity: 1, transform: "translateY(0px)"},
  items: true,
};
